import React from 'react';
import {
  FormErrorMessage as ChakraFormErrorMessage,
  FormErrorMessageProps as ChakraFormErrorMessageProps,
} from '@chakra-ui/react';

export function FormErrorMessage(props: ChakraFormErrorMessageProps) {
  return (
    <ChakraFormErrorMessage
      fontFamily={'Ambit-Regular, Inter, sans-serif'}
      fontSize={'12px'}
      color={'error.main'}
      {...props}
    />
  );
}
